import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectSimple from "../../../components/SelectSimple/SelectSimple";

class SelectSimplePoloPetroquimico extends Component {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        value: PropTypes.any.isRequired,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        value: null,
        disabled: false,
    };

    render() {
        const { disabled, value } = this.props;

        const opcionesPoloPetroquimico = [
            { value: true, label: "Si" },
            { value: false, label: "No" },
        ]

        return (
            <SelectSimple
                name={"polo_petroquimico"}
                options={opcionesPoloPetroquimico}
                value={opcionesPoloPetroquimico.find(opcion => opcion.value === value)}
                disabled={disabled}
            />
        );
    }
}

export default SelectSimplePoloPetroquimico;


// WEBPACK FOOTER //
// ./src/views/clientes/Empresas/SelectSimplePoloPetroquimico.js